var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons ",
    clipPath: "url(#clip0_1695_55116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1695_55116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1695_55116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "do_not_disturb_on",
    d: "M7 10.75H13C13.2125 10.75 13.3906 10.6781 13.5344 10.5344C13.6781 10.3906 13.75 10.2125 13.75 10C13.75 9.7875 13.6781 9.60938 13.5344 9.46563C13.3906 9.32188 13.2125 9.25 13 9.25H7C6.7875 9.25 6.60938 9.32188 6.46562 9.46563C6.32187 9.60938 6.25 9.7875 6.25 10C6.25 10.2125 6.32187 10.3906 6.46562 10.5344C6.60938 10.6781 6.7875 10.75 7 10.75ZM10 17.5C8.9625 17.5 7.9875 17.3031 7.075 16.9094C6.1625 16.5156 5.36875 15.9813 4.69375 15.3063C4.01875 14.6313 3.48438 13.8375 3.09063 12.925C2.69687 12.0125 2.5 11.0375 2.5 10C2.5 8.9625 2.69687 7.9875 3.09063 7.075C3.48438 6.1625 4.01875 5.36875 4.69375 4.69375C5.36875 4.01875 6.1625 3.48438 7.075 3.09063C7.9875 2.69687 8.9625 2.5 10 2.5C11.0375 2.5 12.0125 2.69687 12.925 3.09063C13.8375 3.48438 14.6313 4.01875 15.3063 4.69375C15.9813 5.36875 16.5156 6.1625 16.9094 7.075C17.3031 7.9875 17.5 8.9625 17.5 10C17.5 11.0375 17.3031 12.0125 16.9094 12.925C16.5156 13.8375 15.9813 14.6313 15.3063 15.3063C14.6313 15.9813 13.8375 16.5156 12.925 16.9094C12.0125 17.3031 11.0375 17.5 10 17.5Z",
    fill: "#FBFBFB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1695_55116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.12012ffa3544b99e1647b74577c72644.svg";
export { ForwardRef as ReactComponent };